export type Timezone = string & {_timezoneBrand: never}
export type IanaTimezone = string & {_ianaTimezoneBrand: never}

/**
 * Colloquial timezones mapped to IANA timezones.
 *
 * We currently support timezones in US and CA.
 */
export const TZ_TO_IANA_TZ  = {
  'Pacific': 'America/Los_Angeles' as IanaTimezone,
  'Eastern': 'America/New_York' as IanaTimezone,
  'Central': 'America/Chicago' as IanaTimezone,
  'Mountain': 'America/Denver' as IanaTimezone,
  'Alaska': 'America/Anchorage' as IanaTimezone,
  'Hawaii-Aleutian': 'Pacific/Honolulu' as IanaTimezone,
  'Samoa': 'Pacific/Pago_Pago' as IanaTimezone,
  'Chamorro': 'Pacific/Guam' as IanaTimezone,
  'Atlantic': 'America/Halifax' as IanaTimezone,
  'Newfoundland': 'America/St_Johns' as IanaTimezone,
}

/**
 * Maps timezones to IANA Timezones.
 * References:
 * https://en.wikipedia.org/wiki/List_of_time_zones_by_country
 * https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
 */
export const tzToIanaTz = (tz: Timezone): IanaTimezone => {
  return (TZ_TO_IANA_TZ as {[tz: string]: IanaTimezone})[tz]
}

export const TIMEZONES = Object.keys(TZ_TO_IANA_TZ).sort() as Timezone[]



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/utils/timezone.ts